import { render, staticRenderFns } from "./_Banners.vue?vue&type=template&id=0965c871&scoped=true&"
import script from "./_Banners.vue?vue&type=script&lang=js&"
export * from "./_Banners.vue?vue&type=script&lang=js&"
import style0 from "./_Banners.vue?vue&type=style&index=0&id=0965c871&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965c871",
  null
  
)

export default component.exports